"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default(_ref) {
  var numerator = _ref.numerator,
      denominator = _ref.denominator;
  return _I18n.default.text('i18n.numberRepresentation.fraction', {
    numerator: numerator,
    denominator: denominator
  });
};

exports.default = _default;
module.exports = exports.default;